<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
@import url('./common/fonts/iconfont.css');
@import url('./style/main.scss');
*{
  margin: 0;
  padding: 0;
}
#app {
  width: 100%;
  height: 100%;
  font-family: 'Microsoft Yahei';
  /*font-weight: lighter;*/
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// App.vue?3943a937